// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#progressBar,#progressBarContainer{z-index:1000}.fade-enter-active,.fade-leave-active{transition:opacity .5s}.fade-enter,.fade-leave-to{opacity:0}@media screen and (max-width:767px){#progressBar,#progressBarContainer{display:none}}", ""]);
// Exports
module.exports = exports;
